import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, TextField, Button, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from "react-i18next";
import 'react-toastify/dist/ReactToastify.css';
const CreateProject = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();  

  const { t } = useTranslation();

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  useEffect(() => {
    // Kullanıcı bilgilerini local storage'dan al
    const user = JSON.parse(localStorage.getItem('user'));

    // Eğer kullanıcı yoksa veya roleId 1 değilse projeler sayfasına yönlendir
    if (!user || user.roleId !== 1) {
      navigate('/projects');
    }
  }, [navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await api.post('/api/projects', { name, description }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      // Başarılı Toastify mesajı ve navigate işlemi
      toast.success(t("project_created_success"), {
        position: "top-right",
        autoClose: 3000,
        onClose: () => navigate("/projects"),
      });

    } catch (error) {
      toast.error(t("project_creation_failed", { error: error.response?.data?.error || error.message }), {
        position: "top-right",
        autoClose: 5000,
      });
    }
  };

  return (
    <Container maxWidth="sm">
    <ToastContainer />
    <Box mt={5}>
      <Typography variant="h4" gutterBottom>
        {t("create_project")}
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label={t("project_name")}
          fullWidth
          margin="normal"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          label={t("description")}
          fullWidth
          margin="normal"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <Button variant="contained" color="primary" type="submit" fullWidth>
          {t("create_project_button")}
        </Button>
      </form>
      {message && <Typography color="error">{message}</Typography>}
    </Box>
  </Container>
  );
};

export default CreateProject;
